import i from './master-forwarder.container';

export default i;
